import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import 'altcha';

// Disable console logs based on environment
const loggingEnabled = environment?.enableLogging ?? true;
if (!loggingEnabled) {
    const noop = () => {};
    console.log = noop;
    console.debug = noop;
    console.info = noop;
    console.warn = noop;
    console.error = noop;
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
